/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-07-10 10:00:00
 *
 *******************************************************/
// @flow
import React, { useState } from 'react';
import { Modal, TextContainer, Checkbox, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  active: boolean,
  removing: boolean,
  handleCancel: () => void,
  handleConfirm: () => void
};

type ComposedProps = Props & WithI18nProps;

const WarningUpgradeTurboThemeModal = (props: ComposedProps) => {
  const { active, handleConfirm, handleCancel, i18n } = props;
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  return (
    <Modal
      open={active}
      onClose={handleCancel}
      title={i18n.translate('AdminHTML.PredictiveBundle.WarningThemeTurboPopup.title')}
      primaryAction={{
        content: i18n.translate('AdminHTML.PredictiveBundle.WarningThemeTurboPopup.action02'),
        onAction: () => handleConfirm(doNotShowAgain)
      }}
      secondaryActions={[
        {
          content: (
            <div className="dont-show-again">
              <Checkbox
                checked={doNotShowAgain}
                onChange={() => setDoNotShowAgain(!doNotShowAgain)}
                label={i18n.translate(
                  'AdminHTML.PredictiveBundle.WarningThemeTurboPopup.checkbox_Content'
                )}
              />
            </div>
          )
        },
        {
          content: i18n.translate('AdminHTML.PredictiveBundle.WarningThemeTurboPopup.action01'),
          onAction: () => history.push(routes.shopifyIntegration.view())
        }
      ]}>
      <Modal.Section>
        <TextContainer>
          <p>
            {i18n.translate('AdminHTML.PredictiveBundle.WarningThemeTurboPopup.content', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.PredictiveBundle.WarningThemeTurboPopup.content_t')}
                </TextStyle>
              )
            })}
          </p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};

export default withI18n()(WarningUpgradeTurboThemeModal);
